import React from 'react';
import PaginationStyles from '../../assets/stylesheets/common/Pagination.module.css';
import { ReactComponent as ArrowLeft } from '../../assets/icons/left.svg';
import { ReactComponent as ArrowRight } from '../../assets/icons/right.svg';

function Pagination({ 
  currentPage, 
  totalPages, 
  totalItems, 
  itemsPerPage, 
  onPageChange, 
  loading = false 
}) {

  if (totalPages <= 1 || totalItems === 0) return null;

  const handlePageClick = (page) => {
    if (page !== currentPage && page >= 1 && page <= totalPages && !loading) {
      onPageChange(page);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1 && !loading) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages && !loading) {
      onPageChange(currentPage + 1);
    }
  };

  const getPageNumbers = () => {
    const delta = 1;
    const range = [];
    const rangeWithDots = [];
    const start = Math.max(1, currentPage - delta);
    const end = Math.min(totalPages, currentPage + delta);

    for (let i = start; i <= end; i++) range.push(i);

    if (start > 1) {
      rangeWithDots.push(1);
      if (start > 2) rangeWithDots.push('...');
    }

    rangeWithDots.push(...range);

    if (end < totalPages) {
      if (end < totalPages - 1) rangeWithDots.push('...');
      rangeWithDots.push(totalPages);
    }

    return rangeWithDots;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className={PaginationStyles.paginationWrapper}>
      <button
        className={`${PaginationStyles.navArrow} ${currentPage === 1 || loading ? PaginationStyles.disabled : ''}`}
        onClick={handlePrevious}
        disabled={currentPage === 1 || loading}
        aria-label="Previous page"
      >
        <ArrowLeft className={PaginationStyles.arrowIcon} />
      </button>

      {pageNumbers.map((page, index) => (
        <button
          key={index}
          className={`${PaginationStyles.pageNumber} ${
            page === currentPage ? PaginationStyles.active : ''
          } ${page === '...' ? PaginationStyles.dots : ''}`}
          onClick={() => typeof page === 'number' && handlePageClick(page)}
          disabled={page === '...' || loading}
        >
          {page}
        </button>
      ))}

      <button
        className={`${PaginationStyles.navArrow} ${currentPage === totalPages || loading ? PaginationStyles.disabled : ''}`}
        onClick={handleNext}
        disabled={currentPage === totalPages || loading}
        aria-label="Next page"
      >
        <ArrowRight className={PaginationStyles.arrowIcon} />
      </button>
    </div>
  );
}

export default Pagination;
